import { render, staticRenderFns } from "./logistics-info.vue?vue&type=template&id=3eca2d43&scoped=true&"
import script from "./logistics-info.vue?vue&type=script&lang=js&"
export * from "./logistics-info.vue?vue&type=script&lang=js&"
import style0 from "./logistics-info.vue?vue&type=style&index=0&id=3eca2d43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eca2d43",
  null
  
)

export default component.exports